import { Injectable } from '@angular/core';

import * as fastLevenshtein from 'fast-levenshtein';

export interface LevenshteinObject {
    elem: string | { [key: string]: string };
    distance: number;
}

@Injectable({
    providedIn: 'root',
})
export class LevenshteinService {
    public defaultDistance = 5;
    private opts: fastLevenshtein.LevenshteinOptions = { useCollator: true };

    public calculateDistance(elem: string, text: string): number {
        if (text) {
            if (elem.includes(text.toUpperCase())) {
                return 0;
            }
            const tableauElem: string[] = elem.split(' ');
            let minDistance: number = 999;

            tableauElem.forEach((element) => {
                const distance = fastLevenshtein.get(element, text, this.opts);
                if (distance < minDistance) {
                    minDistance = distance;
                }
            });

            return minDistance;
        }
    }

    public calculateDistances(elemToCalculate: string[], searchText: string, fullText: boolean = false): any[] {
        const elemtDistance: any[] = [];

        elemToCalculate.forEach((elem) => {
            elemtDistance.push({
                elem,
                distance: fullText
                    ? fastLevenshtein.get(elem, searchText.toUpperCase(), this.opts)
                    : this.calculateDistance(elem, searchText),
            });
        });
        elemtDistance.sort((elem1, elem2) => elem1.distance - elem2.distance);
        return elemtDistance;
    }

    public calculateDistancesFromObject(
        elemToCalculate: { [key: string]: string }[],
        attribute: string,
        searchText: string,
        replacePattern: RegExp = null,
        fullText: boolean = false,
    ) {
        const elemtDistance: LevenshteinObject[] = [];

        elemToCalculate.forEach((elem) => {
            const a = replacePattern ? elem[attribute].replace(replacePattern, '') : elem[attribute];
            const b = replacePattern ? searchText.toUpperCase().replace(replacePattern, '') : searchText.toUpperCase();

            elemtDistance.push({
                elem,
                distance: fullText ? fastLevenshtein.get(a, b, this.opts) : this.calculateDistance(a, b),
            });
        });
        elemtDistance.sort((elem1, elem2) => elem1.distance - elem2.distance);
        return elemtDistance;
    }
}
